<template>
    <div class="promocion-se">
        <div class="overflow-auto background-images">
            <Container :title="title" :menu="menu" :theme="theme"></Container>
        </div>
    </div>
</template>
<script>
/* import Header from '@/components/header/AppBar.vue'
import Footer from '@/components/footer/FooterBar.vue' */
import Container from '@/components/contenedor/Container'
import { promoEnums } from '@/components/util/promocionEnum'
//import appService from '@/services/appService'
export default {
    name: 'EcomerceView',
    components: {
        Container,
        /* Header,
        Footer */
    },
    data() {
        return {
            title: 'Admintracion Modulos',
            menu: [],
            theme: 'green lighten-1'
        }
    },
    props: {
        color: {
            type: String,
            default: 'red',
            require: true
        },
        modulo: {
            type: Number,
            default: 0,
            require: true
        },
    },
    computed: {
    },
    methods: {
        async getPromocion() {
            // let respuesta = await appService.consultaPromocion();
            // let data = respuesta.data.data;
            this.loadPagePromo(4);
        },
        loadPagePromo(valor) {

            switch (valor) {
                case promoEnums.DATOS:
                    if (this.$route.path !== '/promociones/descuento') {
                        this.$router.push({ path: '/promociones/descuento' })
                    }
                    break;
                case promoEnums.DIAMADRE:
                    if (this.$route.path !== '/promociones/diamadre') {
                        this.$router.push({ path: '/promociones/diamadre' })
                    }
                    break;
                case promoEnums.SORTEO:
                    if (this.$route.path !== '/promociones/sorteo') {
                        this.$router.push({ path: '/promociones/sorteo' })
                    }
                    break;
                    case promoEnums.BANNERS:
                    if (this.$route.path !== '/promociones/redimibles') {
                        this.$router.push({ path: '/promociones/redimibles' })
                    }
                    break;

                default:
                    if (this.$route.name !== 'pageNotFound') {
                        this.$router.push({ path: '/promociones/.' })
                    }
            }
        },
    },

    async beforeMount() {
        await this.getPromocion();

    },
    created() {
    }
}
</script>
<style scoped>
.promocion-se {
    background: url('/src/assets/images/img-redimibles/fondo.png') no-repeat center center fixed;
    background-size: cover;
}
</style>